const safetyUrl = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:1550/api' : window.safetyUrl
var url = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:1550/api' : window.baseUrl

const baseUrl = url
export default {
  baseUrl: baseUrl, // 把路径导出来
  auth: safetyUrl + '/gzh/auth',
  getWxConfig: safetyUrl + '/gzh/get_wx_config',
  getWxUserInfo: safetyUrl + '/gzh/get_user_info',
  createUserToken: safetyUrl + '/gzh/create_user_token',
  changeUserToken: safetyUrl + '/gzh/change_user_token',
  getUserCustomData: safetyUrl + '/gzh/get_custom_data',
  verifiAuth: safetyUrl + '/gzh/verifi_auth',
  getUserInfoByOpenid: safetyUrl + '/gzh/get_user_info_by_openid',
  insertBrowseHist: baseUrl + '/index/insert_browse_hist',
  getFollowPublicAccount: safetyUrl + '/gzh/get_follow_public_account'
}
